import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo.jsx';

export default function LegalLayout({ title, children }) {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  return (
    <div className="min-h-screen bg-[#0A0A0F] text-white">
      <header className="border-b border-white/5 backdrop-blur-xs">
        <div className="max-w-[760px] mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition">
            <Logo size="sm" showTagline={false} />
          </Link>
          <Link to="/login" className="text-sm text-white/70 hover:text-white transition">
            Log in
          </Link>
        </div>
      </header>

      <main className="max-w-[760px] mx-auto px-6 py-12 leading-relaxed legal-content">
        {children}
      </main>

      <footer className="border-t border-white/5 mt-12">
        <div className="max-w-[760px] mx-auto px-6 py-8 text-sm text-white/55 space-y-3">
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <span className="text-white/20">·</span>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <span className="text-white/20">·</span>
            <Link to="/sms-policy" className="hover:text-white">SMS Policy</Link>
          </div>
          <div className="text-white/40">
            CIVIX LLC · 5600 S Quebec St Suite 300, Greenwood Village, CO 80111 ·{' '}
            <a href="mailto:ceo@civixcrm.ai" className="underline underline-offset-2 hover:text-white/70">
              ceo@civixcrm.ai
            </a>
          </div>
          <div className="text-white/30 text-xs">
            © {new Date().getFullYear()} CIVIX LLC. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
